import {createSlice} from "@reduxjs/toolkit";

const initialCashfreeTransactionsReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  cashfreePaymentMethodStatusList: [], 
  banksStatusList: [], 
  exportData: [], 
  cashfreetransactionsreportlist: [],
  usersCount: null,
  wallet: null,
  walletrmg: null,
  staffUserForEdit: {},
  logs:{
    entities:[],
    totalCount: 0,
  },
  queries:{
    entities:[],
    totalCount: 0,
  },
  contacts:{
    entities:[],
    totalCount: 0,
  },
  contests:{
    entities:[],
    totalCount: 0,
  },
  tournamnets:{
    entities:[],
    totalCount: 0,
  },
  transactions:{
    entities:[],
    totalCount: 0,
  },
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const CashfreeTransactionsReportSlice = createSlice({
  
  name: "cashfreeTransactionsReport",
  initialState: initialCashfreeTransactionsReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    // getstaffUserById
    cashfreeTransactionsReportList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    cashfreePaymentMethodsList: (state, action) => {
      const { cashfreePaymentMethodStatusList, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.cashfreePaymentMethodStatusList = cashfreePaymentMethodStatusList;
    },
    banksList: (state, action) => {
      const { banksStatusList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.banksStatusList = banksStatusList;
    },
    cashfreeTransactionsReportExport: (state, action) => {
      const { exportData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.exportData = exportData;
    },
  }
});
